<template>
  <main-template>
    <!-- Header Section -->
    <v-card class="mb-6" elevation="2">
      <v-card-text class="pa-4">
        <v-row align="center" no-gutters>
          <v-col>
            <div class="d-flex align-center">
              <v-btn color="primary" x-small text @click="goBack" class="mr-2">
                <v-icon left>fa fa-angle-left</v-icon>
              </v-btn>
              <v-icon color="primary" size="large" class="mr-3">mdi-account-group</v-icon>
              <div>
                <h1 class="text-h4 font-weight-bold text-primary mb-1">
                  Configuração de Frequência
                </h1>
                <p class="text-subtitle-1 text-medium-emphasis mb-0">Turma - Bolsa Família</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Main Content Card -->
    <v-card elevation="3">
      <v-card-title class="bg-primary white--text pa-4">
        <v-icon color="white" class="mr-2">mdi-cog</v-icon>
        Configurações de Frequência Mínima
      </v-card-title>

      <v-card-text class="pa-6">
        <!-- Header da Tabela -->
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-school</v-icon>
              <span class="text-h6 font-weight-medium text-primary"> Tipo de Ensino </span>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <v-icon color="success" class="mr-2">mdi-percent</v-icon>
              <span class="text-h6 font-weight-medium text-success"> Frequência Mínima (%) </span>
            </div>
          </v-col>
        </v-row>

        <v-divider class="mb-4"></v-divider>

        <!-- Lista de Tipos de Ensino -->
        <v-container class="pa-0">
          <v-row v-for="(tipo, index) in tiposDeEnsinosList" :key="tipo.id || index" class="mb-4">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="tipo.descricao"
                variant="outlined"
                density="comfortable"
                readonly
                prepend-inner-icon="mdi-book-open-variant"
                bg-color="grey-lighten-5"
                label="Descrição do Ensino"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="tipo.frequencia_minima"
                v-mask="'###'"
                placeholder="Ex: 75"
                label="Frequência Mínima"
                prepend-inner-icon="mdi-calculator"
                suffix="%"
                type="text"
                :rules="[
                  (v) => v !== '' || 'Obrigatório',
                  (v) => (!isNaN(v) && parseInt(v) <= 100) || 'Máximo permitido: 100%',
                ]"
              />
            </v-col>
          </v-row>
        </v-container>

        <!-- Informação Adicional -->
        <v-alert type="info" variant="tonal" class="mb-6" border-color="info">
          <template v-slot:prepend>
            <v-icon>mdi-information</v-icon>
          </template>
          <div>
            <strong>Dica:</strong> A frequência mínima deve ser definida como um número entre 0 e
            100, representando a porcentagem de presença necessária para o programa Bolsa Família.
          </div>
        </v-alert>

        <!-- Botões de Ação -->
        <v-row class="mt-6">
          <v-col cols="12" class="d-flex justify-end flex-wrap ga-3">
            <v-btn color="success" size="large" elevation="2" @click="enviarDados">
              <v-icon start>mdi-check-circle</v-icon>
              Enviar Dados
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </main-template>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      tiposDeEnsinosList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {},
  methods: {
    async loadData() {
      this.$loaderService.open("Carregando dados");
      try {
        this.tiposDeEnsinosList = await this.$services.tiposDeEnsinosService.syncAll();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async enviarDados() {
      const invalido = this.tiposDeEnsinosList.some(
        (tipo) => tipo.frequencia_minima > 100 || tipo.frequencia_minima === ""
      );
      if (invalido) {
        this.$toast.danger("Preencha corretamente todos os campos obrigatórios.");
        return;
      }
      try {
        this.$loaderService.open("Salvando dados");
        await Promise.all(
          this.tiposDeEnsinosList.map((tipo) =>
            this.$services.tiposDeEnsinosService.atualizarTipoDeEnsino(tipo)
          )
        );
        this.$toast.success("Frequência mínima atualizada");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    onlyNumberInput(event) {
      const key = event.key;

      // Permitir controle (setas, delete, backspace, etc.)
      const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
      if (allowedKeys.includes(key)) return;

      // Impede qualquer coisa que não seja número
      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    },

    goBack() {
      this.$router.push({
        name: "home",
      });
    },
  },
};
</script>

<style></style>
